import { CountryDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as CountryActions from './country.actions';

export const COUNTRY_FEATURE_KEY = 'country';

export interface CountryState extends EntityState<CountryDto> {
  selectedCountryId?: string | number; // which Country record has been selected
  loaded: boolean; // has the Country list been loaded
  error?: string | null; // last none error (if any)
}

export interface CountryPartialState {
  readonly [COUNTRY_FEATURE_KEY]: CountryState;
}

export const countryAdapter: EntityAdapter<CountryDto> = createEntityAdapter<
  CountryDto
>({
  selectId: (country) => country.id,
  sortComparer: false,
});

export const initialState: CountryState = countryAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedCountryId: null,
});

const countryReducer = createReducer(
  initialState,
  on(CountryActions.loadCountry, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CountryActions.loadCountrySuccess, (state, { country }) =>
    countryAdapter.addAll(country, { ...state, loaded: false })
  ),
  on(CountryActions.loadCountryFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CountryActions.addCountry, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CountryActions.addCountrySuccess, (state, { newCountry }) =>
    countryAdapter.addMany(newCountry, { ...state, loaded: false })
  ),
  on(CountryActions.addCountryFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CountryActions.updateCountry, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CountryActions.updateCountrySuccess, (state, { updateCountry }) =>
    countryAdapter.upsertMany(updateCountry, { ...state, loaded: false })
  ),
  on(CountryActions.updateCountryFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(CountryActions.removeCountry, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(CountryActions.removeCountrySuccess, (state, { ids }) =>
    countryAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(CountryActions.removeCountryFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: CountryState | undefined, action: Action) {
  return countryReducer(state, action);
}
